export const nhlQuestionTemplates = [
  { text: "PlayerA +X.5 goals", template: "player_goals" },
  { text: "PlayerA +X.5 PTS", template: "player_points" },
  { text: "PlayerA +X.5 PPG", template: "player_power_play_goals" },
  { text: "PlayerA + X.5 SHG", template: "player_short_handed_goals" },
  { text: "PlayerA + X.5 Assists", template: "player_assists" },
  { text: "PlayerA + X.5 PIM", template: "player_pim" },
  { text: "PlayerA + X.5 Takeaway", template: "player_takeaway" },
  { text: "PlayerA + X.5 Hits", template: "player_hits" },
  { text: "PlayerA + X.5 Blocks", template: "player_blocked_shots" },
  { text: "PlayerA + X.5 FO%", template: "player_face_off_pct" },
  { text: "PlayerA + X.5 Saves", template: "player_saves" },
  { text: "PlayerA + X.5 Shots", template: "player_shots_on_target" },
];

export const nflQuestionTemplates = [
  { text: "PlayerA +X.5 PAS Yds", template: "player_passing_yards" },
  { text: "PlayerA +X.5 PAS TD ", template: "player_passing_touchdowns" },
  { text: "PlayerA +X.5 REC TD", template: "player_receiving_touchdowns" },
  { text: "PlayerA +X.5 RUS Yds", template: "player_rushing_yards" },
  { text: "PlayerA +X.5 REC Yds", template: "player_receiving_yards" },
  { text: "PlayerA +X.5 Rec", template: "player_receiving_receptions" },
  { text: "PlayerA +X.5 PAS Com", template: "player_passing_completions" },
  { text: "PlayerA +X.5 PAS Att", template: "player_passing_attempts" },
];
